
<span>{{item().nummer}}</span>
@if (item().subnummer > 0) {
  <span>/{{item().subnummer}}</span>
}
<span> - {{item().kurzbez}}</span>
